module.exports = __webpack_public_path__ + "img/violeta.394c1cb1.svg";